module.exports = __webpack_public_path__ + "img/award-content-ms.fa28dc41.png";